import { useCallback, useMemo } from 'react'
import { Link } from 'react-router-dom'
import { ChevronLeft, History } from 'lucide-react'
import { PageHeader } from '@/shell/AppShell'
import { DataTable } from '@/components/DataTable'
import type { AdminColumn } from '@/components/DataTable/types'
import { PERMISSIONS } from '@/lib/permissions'
import { fetchVerifierAudit, VERIF_STR as S, type VerifierAuditRow } from './verifApi'

/**
 * A9.11 — Verifikator faoliyati auditi. Uchinchi tomon verifikatorlar bajargan
 * amallar jurnali (kim, kimga, qachon). Backend `/admin/verifiers/audit`
 * greenfield → fail-soft (bo'sh); endpoint chiqqach avtomatik to'ladi.
 */
export function VerifierAudit() {
  const columns = useMemo<AdminColumn<VerifierAuditRow>[]>(
    () => [
      { key: 'id', header: 'ID', type: 'id', width: 70 },
      { key: 'created_at', header: S.checkedAt, type: 'date', width: 160 },
      { key: 'verifier', header: S.company, type: 'text', minWidth: 160 },
      { key: 'actor', header: S.actor, type: 'text', width: 160 },
      {
        key: 'action',
        header: S.action,
        type: 'enum',
        width: 130,
        options: [
          { value: 'grant', label: S.actGrant, status: 'active' },
          { value: 'revoke', label: S.actRevoke, status: 'deleted' },
          { value: 'update', label: S.actUpdate, status: 'review' },
          { value: 'login', label: S.actLogin, status: 'pending' },
        ],
      },
      {
        key: 'target_user',
        header: S.targetUser,
        type: 'text',
        width: 160,
        sortable: false,
        render: (r) => (r.target_user ? r.target_user : '—'),
      },
      { key: 'note', header: S.note, type: 'longtext', minWidth: 160 },
    ],
    [],
  )

  const fetcher = useCallback(fetchVerifierAudit, [])

  return (
    <>
      <PageHeader
        title={S.audit}
        screenId="A9.11"
        description={S.auditNote}
        actions={
          <Link
            to="/verification/verifiers"
            className="inline-flex items-center gap-1 rounded-md border border-border-default bg-surface-2 px-2.5 py-1 text-sm text-secondary hover:text-primary"
          >
            <ChevronLeft size={13} />
            {S.verifiers}
          </Link>
        }
      />
      <DataTable<VerifierAuditRow>
        screenId="A9.11"
        permission={PERMISSIONS.AUDIT_VIEW}
        columns={columns}
        fetcher={fetcher}
        rowId={(r) => String(r.id)}
        exportable
        emptyState={{ icon: <History size={28} strokeWidth={1.5} /> }}
      />
    </>
  )
}
